import ColorConstants from "../defaults/ColorConstants"

export const appBarStyle = (config) => {
if(config.env === "prod"){
    return { backgroundColor: ColorConstants.BlueAlien, color: ColorConstants.WhiteAlien, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}
} else {
    return { backgroundColor: 'red', color: ColorConstants.WhiteAlien, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}
}
}